import { format, parse } from 'date-fns';

export const parseBusinessTime = (value, date) => {
  if (!value || !date) return null;

  const raw = String(value).trim().toLowerCase();
  const formats = ['h:mm aa', 'hh:mm aa', 'h:mm a', 'hh:mm a', 'H:mm', 'HH:mm'];

  for (const pattern of formats) {
    const parsed = parse(raw, pattern, date);
    if (!Number.isNaN(parsed.getTime())) {
      return parsed;
    }
  }

  return null;
};

export const getBusinessDayHours = (companyHours = {}, date) => {
  const dayKey = format(date, 'EEEE').toLowerCase();
  return companyHours?.[dayKey] || null;
};
